import React, { useEffect, useState } from 'react';
import { Box, Card, CardActions, Button, Typography, Divider } from '@mui/material';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Watermark from '@uiw/react-watermark';

export default function CustomCard(props) {

    const [image, setImage] = useState(props.image);

    useEffect(() => {
        if (props.image) setImage(props.image);
        setImage(props.image);
    }, [props.image]);

    return (
        <Box sx={{ minWidth: 240, display: 'flex', alignItems: 'stretch', flexDirection: 'row', height: '100%' }}>
            <Card sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', padding: '20px', width: '100%', justifyContent: 'space-between', backgroundColor: '#38466B', cursor: 'pointer' }}
                onClick={() => props.onClick(props.id)}
            >
                <Box>
                    <Typography style={{ fontWeight: 700 }} variant="h5" component="div">
                        {props.name}
                    </Typography>
                </Box>
                <Watermark
                    height={57}
                    width={200}
                    opacity={0.1}
                    offsetLeft={-1}
                    image="./images/Juvalfri-watermark.svg"
                >
                    <Box sx={{ width: '100%', height: '100%', maxHeight: '250px', display: 'flex', justifyContent: 'center', alignItems: 'center', my: 1 }}>
                        {
                            !image &&
                            <LazyLoadImage style={{ padding: '12px', width: '100%', objectFit: 'contain', height: '100%', borderRadius: '10px', backgroundColor: '#fff' }} src="./images/juvalfri_logo.svg" alt={props.descripcion} />
                        }
                        {image && (
                            <LazyLoadImage style={{ padding: '12px', width: '100%', objectFit: 'contain', height: '100%', borderRadius: '10px', backgroundColor: '#fff' }} src={image} alt={props.descripcion} />
                        )}
                    </Box>
                </Watermark>
                <Box>
                    <Divider variant="middle" sx={{ width: '100%', mb: 1 }} />
                    <Typography variant="body1" className='p-1'>
                        {props.info}
                    </Typography>
                </Box>
            </Card>
        </Box>
    );
}